<template>
  <v-container style="max-width: 95% !important; justify-self: center !important;" class="ma-0 pa-0">
    <v-alert-dialog
      ref="alert"
    >
    </v-alert-dialog>

    <v-dialog
      v-model="dialogCargaMasiva"
      persistent
      max-width="80%"
    >
      <v-card elevation="0">
        <v-card-title class="d-flex justify-space-between align-center">
          <span>Carga Masiva de Empleados</span>
          <v-btn v-if="procesoCargaMasiva <= 3" icon @click="close">
            <v-icon x-large>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-stepper v-model="procesoCargaMasiva">
            <v-stepper-header>
              <v-stepper-step :complete="procesoCargaMasiva > 1" step="1">
                Elegir archivo
                <small class="d-block">Sube el XLSX a analizar</small>
              </v-stepper-step>

              <v-divider />

              <v-stepper-step :complete="procesoCargaMasiva > 2" step="2">
                Análisis del archivo
                <small class="d-block">Validación y listado de errores</small>
              </v-stepper-step>

              <v-divider />

              <v-stepper-step step="3">
                Carga y resultado
                <small class="d-block">Ejecución de la carga y confirmación</small>
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <!-- ========== PASO 1: Elección de archivo ========== -->
              <v-stepper-content step="1">
                <v-alert type="info" dense outlined class="mb-4">
                  Para iniciar la carga masiva selecciona el archivo que contiene la información de los empleados.  
                  Solo se aceptan archivos en formato <strong>.xlsx</strong>.  
                </v-alert>


                <v-file-input
                  v-model="cargaHistoricaItem.archivo"
                  accept=".xlsx"
                  label="Seleccionar archivo de empleados"
                  prepend-icon="mdi-file-excel"
                  :show-size="true"
                  clearable
                />

                <div class="d-flex ga-2">
                  <v-btn
                    color="primary"
                    :disabled="!cargaHistoricaItem.archivo || loadingPreanalisis"
                    @click="iniciarPreanalisis()"
                    outlined
                    dense
                    block
                    :loading="loadingPreanalisis"
                  >
                    <v-icon>
                      mdi-magnify
                    </v-icon>
                    Analizar archivo
                  </v-btn>
                </div>
              </v-stepper-content>

              <!-- ========== PASO 2: Resultado del análisis ========== -->
              <v-stepper-content step="2">
                <template v-if="!analisis.completado">
                  <lottie :options="analysisAnimation" :height="200" />
                  <div class="text-center my-8">
                    <div class="display-1 font-weight-bold brown--text text--darken-2">
                      Analizando archivo…
                    </div>
                    <div class="subtitle-1 grey--text">
                      Validando estructura, tipos de datos, formatos de fecha y campos obligatorios
                    </div>
                  </div>
                </template>
                
                <template v-else>
                  <v-alert
                    v-if="analisis.mensajes.length > 0"
                    type="error"
                    dense
                    class="mb-4"
                  >
                    Se encontraron <strong>{{ analisis.mensajes.length }}</strong> errores.
                    Deberá corregirlos y ejecutar nuevamente el análisis.
                  </v-alert>

                 <template v-else>
                  <div class="text-center my-6">
                    <v-icon size="128" color="green">mdi-file-check-outline</v-icon>
                    <div class="title font-weight-bold green--text">
                      ¡El análisis no encontró errores!
                    </div>
                    <div class="subtitle-1 grey--text">
                      Puede continuar al siguiente paso.
                    </div>
                  </div>
                 </template>

                  <template v-if="analisis.mensajes.length > 0">
                    <v-data-table
                      :items="analisis.mensajes"
                      :headers="headersErroresPreanalsis"
                      hide-default-footer
                      :items-per-page="-1"
                    >
                      <template v-slot:[`item.tipo_alerta`]="{ item }">
                        <v-icon
                          v-if="item.tipo_alerta == 1"
                          color="red"
                        >
                          mdi-close-octagon
                        </v-icon>
                        <v-icon
                          v-else
                          color="yellow"
                        >
                          mdi-alert
                        </v-icon>
                      </template>
                    </v-data-table>
                    <br>
                  </template>
                </template>

                <div class="d-flex ga-2">
                  <v-btn
                    text
                    @click="restablecerFlujoCargaMasiva"
                  >
                    Regresar
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    :disabled="!analisis.completado || analisis.mensajes.filter(x => x.tipo_alerta == 1).length > 0 || loadingCargaMasiva"
                    @click="iniciarCargaMasiva"
                    :loading="loadingCargaMasiva"
                  >
                    Iniciar Carga Masiva
                  </v-btn>
                </div>
              </v-stepper-content>

              <!-- ========== PASO 3: Cargando + Resultado final ========== -->
              <v-stepper-content step="3" class="text-center">
                <template v-if="!carga.completado">
                  <lottie :options="gearAnimation" :height="200" />
                  <div class="text-center my-8">
                    <div class="display-1 font-weight-bold brown--text text--darken-2">
                      Procesando Archivo…
                    </div>
                    <div class="subtitle-1 grey--text">
                      Se está realizando la carga masiva de empleados; por favor espere mientras finaliza el proceso. Este procedimiento puede tardar dependiendo del tamaño del archivo.
                    </div>
                  </div>
                </template>


                <template v-else>
                  <v-icon
                    color="green"
                    size="200"
                  >
                    mdi-check-circle
                  </v-icon>
                  <div class="text-center my-8">
                    <div class="display-1 font-weight-bold brown--text text--darken-2">
                      Carga Masiva Realizada Correctamente
                    </div>
                    <div class="subtitle-1 grey--text">
                      Todos los empleados fueron registrados exitosamente en el sistema.
                    </div>
                  </div>

                  <div class="d-flex ga-2">
                    <v-btn color="primary" @click="restablecerFlujoCargaMasiva">Iniciar nueva carga</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text @click="close">Cerrar</v-btn>
                  </div>
                </template>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import VAlertDialog from '@/components/VAlertDialog.vue'
import { mapState } from 'vuex'
import Lottie from 'vue-lottie';
import analysisAnimationData from '@/assets/analysis.json';
import gearAnimationData from '@/assets/gear.json';

export default {
  components: {
    VAlertDialog,
    'lottie': Lottie,
  },
  computed: {
    ...mapState(['token'])
  },
  data: () => ({
    analysisAnimation: { animationData: analysisAnimationData, loop: true },
    gearAnimation: { animationData: gearAnimationData, loop: true },
    dialogCargaMasiva: false,
    headersErroresPreanalsis: [
      {
        text: "Alerta",
        value: "tipo_alerta",
        align: "center",
        width: "10%",
        sortable: false
      },
      {
        text: "Mensaje",
        value: "mensaje",
        align: "left",
        width: "90%",
        sortable: false
      }
    ],
    procesoCargaMasiva: 1,
    idJobPreanalisis: null,
    intervalPreanalisis: null,
    idJobCargaMasiva: null,
    intervalCargaMasiva: null,
    cargaHistoricaItem: {
      archivo: null,
    },
    analisis: {
      completado: false,
      mensajes: []
    },
    carga: {
      completado: false,
    },
    loadingPreanalisis: false,
    loadingCargaMasiva: false,
    defaultCargaHistoricaItem: {
      archivo: null,
    },
    defaultaAnalisis: {
      completado: false,
      mensajes: []
    },
    defaultCarga: {
      completado: false,
    },
  }),
  mounted() {
    this.checkMigracionProgreso();
  },
  methods: {
    open(){
      this.dialogCargaMasiva = true;
    },
    close(){
      this.restablecerFlujoCargaMasiva();
      this.dialogCargaMasiva = false;
    },
    iniciarPreanalisis(){
      this.loadingPreanalisis = true;
      const formData = new FormData();
      formData.append("file", this.cargaHistoricaItem.archivo);

      axios
        .post("/RecursosHumanos/PreAnalisisLanzar", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.procesoCargaMasiva = 2;
          this.idJobPreanalisis = response.data;
          this.iniciarIntervaloPreanalisis();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingPreanalisis = false;
        })
    },
    iniciarIntervaloPreanalisis(){
      if(this.intervalPreanalisis == null){
        this.intervalPreanalisis = setInterval(() => {
          this.actualizarPreanalisisEstado();
        }, 5000);
      }
    },
    detenerIntervaloPreanalisis(){
      if(this.intervalPreanalisis != null){
        clearInterval(this.intervalPreanalisis);
        this.intervalPreanalisis = null;
      }
    },
    actualizarPreanalisisEstado(){
      axios
      .get(`/RecursosHumanos/PreAnalisisEstado/${this.idJobPreanalisis}`)
      .then(response => {
        if(response.data.completado){
          this.detenerIntervaloPreanalisis();
          this.analisis = response.data;
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    iniciarCargaMasiva(){
      this.loadingCargaMasiva = true;

      const formData = new FormData();
      formData.append("file", this.cargaHistoricaItem.archivo);
      
      axios
        .post("/RecursosHumanos/CargaMasivaLanzar", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.procesoCargaMasiva = 3;
          this.idJobCargaMasiva = response.data;
          this.iniciarIntervaloCargaMasiva();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingCargaMasiva = false;
        })
    },
    iniciarIntervaloCargaMasiva(){
      if(this.intervalCargaMasiva == null){
        this.intervalCargaMasiva = setInterval(() => {
          this.actualizarCargaMasivaEstado();
        }, 5000);
      }
    },
    detenerIntervaloCargaMasiva(){
      if(this.intervalCargaMasiva != null){
        clearInterval(this.intervalCargaMasiva);
        this.intervalCargaMasiva = null;
      }
    },
    actualizarCargaMasivaEstado(){
      axios
      .get(`/RecursosHumanos/CargaMasivaEstado/${this.idJobCargaMasiva}`)
      .then(response => {
        if(response.data.completado){
          this.detenerIntervaloCargaMasiva();
          this.carga = response.data;
          this.$emit('change', null);
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    restablecerFlujoCargaMasiva(){
      this.procesoCargaMasiva = 1;
      this.idJobPreanalisis = null;
      this.detenerIntervaloPreanalisis();
      this.idJobCargaMasiva = null;
      this.detenerIntervaloCargaMasiva();
      this.loadingPreanalisis = false;
      this.loadingCargaMasiva = false;
      this.cargaHistoricaItem = Object.assign({}, this.defaultCargaHistoricaItem);
      this.analisis = Object.assign({}, this.defaultaAnalisis);
      this.carga = Object.assign({}, this.defaultCarga);
    },
    checkMigracionProgreso(){
      axios
      .get('/RecursosHumanos/CargaMasivaPendiente')
      .then(response => {
        console.log(response.data.ids_jobs)
        if(response.data.ids_jobs != null && response.data.ids_jobs.length > 0){
          this.dialogCargaMasiva = true;
          this.idJobCargaMasiva = response.data.ids_jobs[0];
          this.procesoCargaMasiva = 4;
          this.iniciarIntervaloCargaMasiva();
        }
      })
      .catch(error => {
        console.log(error)
      })
    }
  }
}
</script>